<!-- <ng-container *ngIf="lookupdata.length > 0"> -->
    <section class="mx-3">
        <ng-container>
          <div class="d-flex justify-content-between align-items-center">
            <div class="page_header">
              <h4 translate class="m-0 page_header_title">Academic  Years List</h4>
            </div>
            <div *ngIf="actiondata?.create">
              <button
                translate
                mat-raised-button
                color="primary"
                (click)="openAddAcademicsDialog()"
                class="px-5 add_button"
              >Add</button>
            </div>
          </div>
          <div class="position-relative">
            @if (isLoadingResults || isRateLimitReached) {
            <div class="loading-shade">
              @if (isLoadingResults) {
              <mat-spinner class="mat_spinner"></mat-spinner>
              }
            </div>
            }
            <ng-container *ngIf="actiondata?.list_view">
            <div class="mt-2 table-container">
              <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
                <ng-container matColumnDef="start_year">
                  <th translate mat-header-cell *matHeaderCellDef>Start Year</th>
                  <td mat-cell *matCellDef="let element">{{ element.start_year }}</td>
                </ng-container>
                <ng-container matColumnDef="end_year">
                  <th translate mat-header-cell *matHeaderCellDef>End Year</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.end_year}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th translate mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let element">
                    <div class="status-container">
                      {{ element.status }}
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                  <th translate mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let row">
                    <div class="d-flex align-items-center">
                    <p translate mat-raised-button  class="m-0 cursor_pointer action_button" (click)="showsemesterdetails(row)">
                      View
                    </p>
                    <ng-container>
                      <div
                      class="action_button"
                      [matMenuTriggerFor]="actionrequest"
                       aria-label="menu"
                    >
                      <i class="fa-solid fa-ellipsis-vertical"></i>
                  </div>
                      <mat-menu #actionrequest="matMenu">
                        <ng-container *ngIf="row.status == 'ACTIVE'">                          
                          <button mat-menu-item class="action_button"
                              (click)="actionrequestapi('INACTIVE', row.id)">
                              <span translate>Disable</span>
                          </button>
                          </ng-container>
                          <ng-container *ngIf="row.status == 'INACTIVE'">                          
                            <button mat-menu-item class="action_button"
                                (click)="actionrequestapi('ACTIVE', row.id)">
                                <span translate>Enable</span>
                            </button>
                            </ng-container>
                      </mat-menu>
                      </ng-container>
                    </div>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                  (click)="selection.toggle(row)"
                ></tr>
                <tr class="mat-row" *matNoDataRow>
                  <td translate class="mat-cell" colspan="4">No data</td>
                </tr>
              </table>
            </div>
            <div class="mt-2" *ngIf="total_count > 5">
              <app-pagination [datafromparent]="total_count" (onDatePicked)="pagination($event)"></app-pagination>
            </div>
          </ng-container>
          </div>
        </ng-container>
      </section>
      